// extracted by mini-css-extract-plugin
export var menu = "menu-module--menu--1xlZ4";
export var link = "menu-module--link--L6aYo";
export var soon = "menu-module--soon--3GAWA";